module.exports = __webpack_public_path__ + "img/convert-bomb-page.837eaf8e.svg";